









































































import { Vue, Component, Prop, Model, Emit } from "vue-property-decorator";
import { Product } from "@/controller/my-routine-products";
import CategoriesPicker from "./CategoriesPicker.vue";
import StepPicker from "./StepPicker.vue";
import { formRules } from "@/const/form-rules";

@Component({
  components: {
    CategoriesPicker,
    StepPicker
  }
})
export default class EditProductPopup extends Vue {
  @Model("input", { type: Boolean, required: true })
  show!: boolean;

  @Prop({ type: Object, required: true })
  product!: Product;

  step = "";
  productUrl = "";
  haravanProductId = "";
  categories: string[] = [];
  name = "";
  description = "";
  imageUrl = "";

  formIsValid = true;
  rules = formRules;

  @Emit("input")
  emitClose() {
    return false;
  }

  @Emit("click")
  emitClick(): Product {
    return {
      step: this.step,
      product_url: this.productUrl as string,
      haravan_product_id: this.haravanProductId as string,
      categories: this.categories,
      name: this.name as string,
      description: this.description as string,
      image_url: this.imageUrl as string
    };
  }

  created() {
    this.initFormData();
  }

  initFormData() {
    this.step = this.product.step;
    this.productUrl = this.product.product_url;
    this.haravanProductId = this.product.haravan_product_id;
    this.categories = this.product.categories;
    this.name = this.product.name;
    this.description = this.product.description;
    this.imageUrl = this.product.image_url;
  }

  onClick() {
    this.validateForm();

    if (this.formIsValid) {
      this.emitClick();
    }
  }

  private validateForm() {
    (this.$refs.form as Vue & { validate: () => boolean }).validate();
  }
}
